import { Component, OnInit, ViewChild } from '@angular/core';
import { SoftwareService } from '../../services/software.service';
import { HaloLoaderService } from '../../../core/halo-loader/halo-loader.service';
import { CommonUtil } from '../../../core/Utils/common-util';
import { NgbTooltip, NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { ILifescapeUpdateClassWrapper, ILifescapeCourseClassWrapper, lifescapeAssetList } from '../../services/software.service.model';
import { SelectionInfo } from '../../selectors/multi-selection/multi-selection.model';
import { Router } from '@angular/router';
import { VideoLibraryService } from '../../video-library/video-library.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FeatureFlagsService } from 'src/app/core/shared-service/feature-flags.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-lifescape-courses',
  templateUrl: './lifescape-courses.component.html',
  styleUrls: ['./lifescape-courses.component.scss']
})
export class LifescapeCoursesComponent implements OnInit {
  hasSoftware = false;
  isLifescapeUpdateOn: boolean = false;
  gatewayStatusMsg: string = 'N.A';
  lifescapeUpdateData: ILifescapeUpdateClassWrapper;
  lifescapeDownloadData: ILifescapeCourseClassWrapper;

  private selectionInfo: SelectionInfo;
  private supportedConsoles = ['superman','hal', 'everest', 'neo_se4', 'falco'];
  isEnabledEquipment = false;
  showEnableEquipment = false;

  // for mobile tooltip
  @ViewChild('sls1', { static: false }) mytooltip1: NgbTooltip;
  @ViewChild('sls2', { static: false }) mytooltip2: NgbTooltip;

  constructor(private softwareService: SoftwareService,
    private loader: HaloLoaderService,
    private commonUtil: CommonUtil,
    private _router: Router,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private _facilityService: FacilityService,
    private _vdoLibraryService: VideoLibraryService,
    private _loader: HaloLoaderService,    
    private _featureFlagService: FeatureFlagsService) { }

  ngOnInit(): void {
    this.getLifescapeDownloadDetails();
  }

  getLifescapeUpdateDetails(): void {
    // load data
    this.loader.startProcess();
    this.softwareService.getLifescapeCoursesUpdates(this.selectionInfo.facility.facilityId.split(","), this.selectionInfo.consoleType).subscribe(
      (data: ILifescapeUpdateClassWrapper) => {
        this.loader.endProcess();
        this.lifescapeUpdateData = data;
        this.setLifescapeData(data);
        if (this.lifescapeUpdateData.lifescapeStatusONFacilityList && this.lifescapeUpdateData.lifescapeStatusONFacilityList.length > 0) {
          this.isLifescapeUpdateOn = true;
        }
      },
      (error) => {
        console.error('API failed.');
        this.loader.endProcess();
      }
    );
  }

  getLifescapeDownloadDetails(): void {
    this.loader.startProcess();
    this.softwareService.getLifescapeDownloadLinks().subscribe(
      (data: ILifescapeCourseClassWrapper) => {
        this.loader.endProcess();
        this.lifescapeDownloadData = data;
      },
      (error) => {
        console.error('API failed.');
        this.loader.endProcess();
      }
    );
  }

  setLifescapeData(lsData: ILifescapeUpdateClassWrapper): void {
    /*setting gatewaystatus message*/
    if (lsData.gatewayLifescapeCourseUpdateStatus) {
      let gStatus = lsData.gatewayLifescapeCourseUpdateStatus;
      if (gStatus == 'complete') {
        this.gatewayStatusMsg = 'SYNC.COMPLETE';
      } else if (gStatus == 'ready') {
        this.gatewayStatusMsg = 'DOWNLOADING.COURSES';
      } else if (gStatus == 'in_error') {
        this.gatewayStatusMsg = 'NOT.CONNECTED';
      } else if (gStatus == 'in_progress') {
        this.gatewayStatusMsg = 'COURSES.DOWNLOADE.SYNCING.WITH.CONSOLES';
      } else {
        this.gatewayStatusMsg = 'N.A';
      }
    }
  }



  saveLifescapeUpdate(isLifescapeUpdateOn: boolean): void {
    this.loader.startProcess();
      this.softwareService
        .saveLifescapeCoursesUpdates(this.selectionInfo.facility.facilityId.split(','), this.selectionInfo.consoleType, isLifescapeUpdateOn)
        .subscribe(
          (data: ILifescapeUpdateClassWrapper) => {
            this.lifescapeUpdateData = data;
            this.setLifescapeData(data);
            this.isLifescapeUpdateOn = isLifescapeUpdateOn;
            if (this.lifescapeUpdateData.lifescapeStatusOFFFacilityList) {
              this.lifescapeUpdateData.lifescapeStatusONFacilityList = [...this.lifescapeUpdateData.lifescapeStatusOFFFacilityList];
            }
            // this._amplitudeAnalytics.logEvent(
            //   'Software - Lifescape Course - Auto Update',
            //   { AutoUpdate_Type: isLifescapeUpdateOn.toString() }
            // );
            this.loader.endProcess();
          },
          (error: any) => {
            console.error('API failed.');
            this.loader.endProcess();
          }
        );
  }

  getassetStatus(courseStatus?: string, onlineFlag?: string): string {
    let statusMsg: string = '';
    if (courseStatus && courseStatus === 'COMPLETE') {
      statusMsg = 'COMPLETE';
    } else if (courseStatus && courseStatus === 'IN_PROGRESS') {
      statusMsg = 'IN.PROGRESS';
    } else if (courseStatus && courseStatus === 'OUT_OF_SPACE') {
      statusMsg = 'IN.ERRORS';
    } else if (onlineFlag && onlineFlag === 'true') {
      statusMsg = 'N.A';
    } else {
      statusMsg = 'IN.ERRORS';
    }
    return statusMsg;
  }

  beforeChange($event: NgbPanelChangeEvent) {
    if ($event.panelId === 'panelOne') {
      $event.preventDefault();
    }

    if ($event.panelId === 'panelTwo' && $event.nextState === false) {
      $event.preventDefault();
    }
  }

  getRowGroupTitle(activityId: string): string {
    let _activityId = '';
    let _shortNames = '';

    switch (parseInt(activityId)) {
      case 1:
        _activityId = 'TREADMILLS';
        _shortNames = 'TREADMILLS';
        break;
      case 2:
        _activityId = 'LIFECYCLE.EXERCISE.BIKES';
        _shortNames = 'LIFECYCLE.EXERCISE.BIKES';
        break;
      case 4:
        _activityId = 'ELLIPTICAL.CROSS.TRAINERS';
        _shortNames = 'EQ.TYPE.4';
        break;
      case 12:
        _activityId = 'SUMMIT.TRAINER';
        _shortNames = 'SUMMIT.TRAINER';
        break;
      case 13:
        _activityId = 'STAIR.CLIMBER';
        _shortNames = 'STAIR.CLIMBER';
        break;
      case 15:
        _activityId = 'FLEXSTRIDER.VARIABLE.STRIDE.TRAINERS';
        _shortNames = 'EQ.TYPE.15';
        break;
      case 16:
        _activityId = 'POWERMILL.CLIMBERS';
        _shortNames = 'EQ.TYPE.16';
        break;
      case 18:
        _activityId = 'GSC.TRAINERS';
        _shortNames = 'GSC.TRAINERS';
        break;
      case 19:
        _activityId = 'EQ.TYPE.19';
        _shortNames = 'EQ.TYPE.19';
        break;
      case 20:
        _activityId = 'EQ.TYPE.20';
        _shortNames = 'EQ.TYPE.20';
        break;
      case 28:
        _activityId = 'PERFORMANCE.TREADMILLS';
        _shortNames = 'PERFORMANCE.TREADMILLS';
        break;
    }
    return _activityId;
  }

  onSelectionChange(selectionInfo: SelectionInfo) {
    setTimeout(() => {
      this.selectionInfo = selectionInfo;
      this.hasSoftware = this.selectionInfo.facility.summary.userRights.software === 'F';
      this.getLifescapeUpdateDetails();
      this.commonUtil.softwareRedirectToFacility('life-scape-course');
      this._checkEquipmentEnabled();
    });
  }

  enableEquipment() {
    this._router.navigate(["/enable_equipment"]);
  }

  private async _checkEquipmentEnabled() {
    let facility = this.selectionInfo.facility;
    if(facility) {
      this._loader.startProcess();
      try {
        let facility = this.selectionInfo.facility;
        if(facility) {
          let data = await this._vdoLibraryService.getEnabledEquipment([Number(facility.facilityId)], this.selectionInfo.consoleType).toPromise() as [];
          if(data && data.length > 0) {
            this.isEnabledEquipment = data.filter((d:any) => d.lifescapeEnabledStatus).length > 0;
            this.showEnableEquipment = facility.summary.facilityRights.lfodEnabledEquipment === 'true' && 
                                       facility.summary.userRights.lfodEnabledEquipment !== 'H' && 
                                       !!this.supportedConsoles.find(s => s === this.selectionInfo.consoleType) &&
                                       this._featureFlagService.isOn('se3HD');
          }
        }      
      } catch (error) {
        this.isEnabledEquipment = false;
        this.showEnableEquipment = false;
        console.error('API error');
      }
      this._loader.endProcess();
    }
  }

}
